module.exports = __webpack_public_path__ + "static/media/platzilogo.52dbbc39.png";